function xmur3(value) {
  let hash = 1779033703 ^ value.length;
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 3432918353);
    hash = (hash << 13) | (hash >>> 19);
  }
  return () => {
    hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
    hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
    return (hash ^= hash >>> 16) >>> 0;
  };
}

function mulberry32(seed) {
  return () => {
    let value = (seed += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffleWithSeed(items, seed) {
  const result = [...items];
  const random = mulberry32(xmur3(String(seed))());
  for (let index = result.length - 1; index > 0; index -= 1) {
    const target = Math.floor(random() * (index + 1));
    [result[index], result[target]] = [result[target], result[index]];
  }
  return result;
}

function cardsForAssets(assets, seed) {
  const cards = assets.flatMap((asset) => [
    { ...asset, cardId: `${asset.id}:a` },
    { ...asset, cardId: `${asset.id}:b` },
  ]);
  return shuffleWithSeed(cards, `${seed}:cards`);
}

export function buildMemoryBoards(assets, pairCount, deckSeeds) {
  const sortedAssets = [...assets].sort((left, right) => left.id.localeCompare(right.id));
  const pairCounts = Array.isArray(pairCount)
    ? pairCount.map(Number)
    : [Number(pairCount), Number(pairCount)];
  if (deckSeeds.length !== 2 || pairCounts.length !== 2 || sortedAssets.length < pairCounts[0] + pairCounts[1]) {
    throw new Error('Hafıza destesi oluşturulamadı.');
  }
  const firstAssets = shuffleWithSeed(sortedAssets, `${deckSeeds[0]}:assets`).slice(0, pairCounts[0]);
  const firstIds = new Set(firstAssets.map((asset) => asset.id));
  const secondAssets = shuffleWithSeed(
    sortedAssets.filter((asset) => !firstIds.has(asset.id)),
    `${deckSeeds[1]}:assets`,
  ).slice(0, pairCounts[1]);
  return [
    cardsForAssets(firstAssets, deckSeeds[0]),
    cardsForAssets(secondAssets, deckSeeds[1]),
  ];
}

export function columnsForPairCount(pairCount) {
  return { 2: 2, 3: 3, 4: 4, 6: 4, 8: 4, 10: 5, 12: 4 }[Number(pairCount)] || 4;
}
